import React, { useState } from 'react';
import { X } from 'lucide-react';
import { SignUpForm } from './SignUpForm';
import { LoginForm } from './LoginForm';

interface AuthModalProps {
  isOpen: boolean;
  onClose: () => void;
  initialMode?: 'login' | 'signup';
}

export const AuthModal: React.FC<AuthModalProps> = ({ 
  isOpen, 
  onClose,
  initialMode = 'signup'
}) => {
  const [mode, setMode] = useState<'login' | 'signup'>(initialMode);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-indigo-950 rounded-lg p-4 md:p-6 w-full max-w-md relative max-h-[90vh] overflow-y-auto">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-purple-200 hover:text-purple-100"
        >
          <X className="w-6 h-6" />
        </button>

        <div className="mb-6">
          <h2 className="text-2xl font-bold text-purple-200 text-center">
            {mode === 'signup' ? 'Criar Conta' : 'Entrar'}
          </h2>
          <p className="text-purple-200/70 text-center mt-2">
            {mode === 'signup' 
              ? 'Comece sua jornada astral'
              : 'Bem-vindo de volta'}
          </p>
        </div>

        {mode === 'signup' ? (
          <>
            <SignUpForm onSuccess={onClose} />
            <p className="text-center mt-4 text-purple-200/70">
              Já tem uma conta?{' '}
              <button
                onClick={() => setMode('login')}
                className="text-purple-300 hover:text-purple-200"
              >
                Entrar
              </button>
            </p>
          </>
        ) : (
          <>
            <LoginForm onSuccess={onClose} />
            <p className="text-center mt-4 text-purple-200/70">
              Ainda não tem conta?{' '}
              <button
                onClick={() => setMode('signup')}
                className="text-purple-300 hover:text-purple-200"
              >
                Criar Conta
              </button>
            </p>
          </>
        )}
      </div>
    </div>
  );
};